module.exports = __webpack_public_path__ + "assets/img/CMTP-Website-w960.d670de30.webp";